import { spacing } from '../../tokens/tokens-base/properties/build/js/index.js';
const ALL_SPACING_LAYOUT_VALUES = Object.keys(spacing.layout);
const ALL_SPACING_INNER_VALUES = Object.keys(spacing.inner);
const buildSpacingVariants = function () {
  let extraValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let valuesToOmit = arguments.length > 1 ? arguments[1] : undefined;
  const VALID_SPACING_VALUES = ALL_SPACING_LAYOUT_VALUES.filter(token => !(valuesToOmit === null || valuesToOmit === void 0 ? void 0 : valuesToOmit.includes(token)));
  const VALID_VALUES = [...VALID_SPACING_VALUES, ...extraValues];
  return VALID_VALUES.reduce((final, validSpacingValue) => {
    return Object.assign(Object.assign({}, final), {
      [validSpacingValue]: {}
    });
  }, {});
};
Object.defineProperty(buildSpacingVariants, 'displayName', {
  value: 'ReactBase_buildSpacingVariants'
});
const buildSpacingInnerVariants = function () {
  let extraValues = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
  let valuesToOmit = arguments.length > 1 ? arguments[1] : undefined;
  const VALID_SPACING_VALUES = ALL_SPACING_INNER_VALUES.filter(token => !(valuesToOmit === null || valuesToOmit === void 0 ? void 0 : valuesToOmit.includes(token)));
  const VALID_VALUES = [...VALID_SPACING_VALUES, ...extraValues];
  return VALID_VALUES.reduce((final, validValue) => {
    return Object.assign(Object.assign({}, final), {
      [validValue]: {}
    });
  }, {});
};
Object.defineProperty(buildSpacingInnerVariants, 'displayName', {
  value: 'ReactBase_buildSpacingInnerVariants'
});
export { buildSpacingInnerVariants, buildSpacingVariants };